/*
 *   File : auth-slider.js
 *   Author : https://evoqins.com
 *   Description : Login and Signup page
 *   Integrations : Auth page left section - slider
 *   Version : 1.0.0
 *   Date : 21-10-2025  
*/

const ONBOARDING_SLIDES = [
    {
        image: require("../../Assets/Images/Onboarding/slides/partner-ship.webp"),
        heading: "A Partnership You Can Trust",
        description: "A promise of secure systems, regulated platforms, and trustworthy investments."
    },
    {
        image: require("../../Assets/Images/Onboarding/slides/vision.webp"),
        heading: "A Vision That Inspires",
        description: "Guided by strong values and trust, index funds empower every investor’s journey."
    },
    {
        image: require("../../Assets/Images/Onboarding/slides/smart-fund-allocation.webp"),
        heading: "Smart Fund Allocation",
        description: "Make informed choices with secure, diversified, and high-return investment options."
    },
    {
        image: require("../../Assets/Images/Onboarding/slides/invest-top-indices.webp"),
        heading: "Invest in India’s Top Indices",
        description: "Secure, transparent, and diversified index fund investments at your fingertips."
    },
];


function AuthSlider() {
    return (
        <div className="col-md-6 d-md-block d-none">

            <div id="onboarding-carousel" className="carousel  slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {
                        ONBOARDING_SLIDES.map((item, index) => (
                            <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                                <img src={item.image} height={200} width={270} draggable="false" className="d-block object-fit-contain" alt={item.heading} />
                                <div className="d-none d-md-block" >
                                    <h5 className="e-text-charleston-green e-alt-font-poppins e-font-weight-600 e-font-20 line-height-28px letter-spacing-neg-2 mb-2">
                                        {item.heading}
                                    </h5>
                                    <p className="e-text-onyx e-alt-font-poppins e-font-weight-400 e-font-12 line-height-20px mb-0 pe-4">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))
                    }

                    <div className="carousel-indicators">
                        {
                            ONBOARDING_SLIDES.map((item, index) => (
                                <button key={index} type="button" data-bs-target="#onboarding-carousel" data-bs-slide-to={index} className={index === 0 ? "active" : ""} aria-current={index === 0 ? "true" : ""} aria-label={`Slide ${index + 1}`}></button>
                            ))
                        }
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AuthSlider;